export default {
  hero_title: 'Tekrar hoş geldiniz!',
  hero_subtitle: 'Yüzünüzü güneşe çevirin, gölgeler arkanızda kalsın.',
  title: 'Estimator24 hesabınıza giriş yapın',
  subtitle: 'Devam etmek için bilgilerinizi girin.',
  email: 'E-posta',
  password: 'Parola',
  remember_me: 'Beni hatırla',
  submit: 'Giriş yap',
  register_link: 'Hesap oluştur'
}
